import { render } from "./AppToasts.vue?vue&type=template&id=2827e9a7&scoped=true"
import script from "./AppToasts.vue?vue&type=script&lang=ts"
export * from "./AppToasts.vue?vue&type=script&lang=ts"

import "./AppToasts.vue?vue&type=style&index=0&id=2827e9a7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2827e9a7"

export default script